// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pagination_wrapper__3QX6M","selected":"pagination_selected__US8n2","disabled":"pagination_disabled__1PV41"};